import Group, { GroupProps } from './group';

const ButtonGroup = ({ ...rest }: GroupProps) => <Group bottomItemMargin={'none'} {...rest} />;

export default ButtonGroup;
